import { useEffect, useState } from 'react';
import { UserCircle, SignOut } from '@phosphor-icons/react';

const FLAG_KEY = 'yublink_impersonating';
const ADMIN_TOKEN_BACKUP = 'yublink_admin_token';
const USER_TOKEN = 'yublink_token';

export default function ImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const read = () => {
      try {
        const raw = localStorage.getItem(FLAG_KEY);
        setInfo(raw ? JSON.parse(raw) : null);
      } catch {
        setInfo(null);
      }
    };
    read();
    // Keep in sync if another tab/component updates the flag
    window.addEventListener('storage', read);
    return () => window.removeEventListener('storage', read);
  }, []);

  const exit = () => {
    const adminToken = localStorage.getItem(ADMIN_TOKEN_BACKUP);
    if (adminToken) {
      localStorage.setItem(USER_TOKEN, adminToken);
      localStorage.removeItem(ADMIN_TOKEN_BACKUP);
    } else {
      localStorage.removeItem(USER_TOKEN);
    }
    localStorage.removeItem(FLAG_KEY);
    // Hard reload to /admin so every provider re-reads the restored admin session
    window.location.href = '/admin';
  };

  if (!info) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-[#D4AF37] via-[#E8C65A] to-[#D4AF37] text-[#060A1A] shadow-[0_4px_20px_rgba(212,175,55,0.5)]"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <UserCircle size={18} weight="fill" />
          <span className="text-[11px] font-bold uppercase tracking-[0.15em] shrink-0">Impersonating</span>
          <span className="text-sm font-semibold truncate">
            {info.first_name || info.email}
            {info.email && info.first_name ? <span className="opacity-60 font-normal"> · {info.email}</span> : null}
          </span>
        </div>
        <button
          onClick={exit}
          data-testid="impersonation-exit-btn"
          className="shrink-0 flex items-center gap-1.5 px-3 py-1 rounded-lg bg-[#060A1A] text-[#D4AF37] text-xs font-bold hover:brightness-125 transition-all"
        >
          <SignOut size={14} weight="bold" /> Exit
        </button>
      </div>
    </div>
  );
}
